import { Text } from 'ui';

import classes from './EmptyCell.module.css';

const EMPTY_CELL_VALUE = '--';

const EmptyCell = () => {
  return (
    <Text className={classes.emptyCell} c="gray.4">
      {EMPTY_CELL_VALUE}
    </Text>
  );
};

export { EmptyCell };
